import React, {Component} from 'react'
import {
    Form,
    Input,
    Row,
    Col,
    Select,
    Button,
    Popconfirm,
    Table, message
} from 'antd';
import {baseUrl, reqCountryCityList, reqAddCountry, reqUpdateCountry, reqDeleteCountry, reqAddCity, reqUpdateCity, reqDeleteCity} from '../../api'
import {Link} from 'react-router-dom'
import CountryModal from './country-model'
import CityModal from './city-model'
import LinkButton from '../../components/link-button'
import moment from 'moment';
import 'moment/locale/zh-cn';
import authorizeBase from "../../components/authorize/authorizeBase";
const AuthButton = authorizeBase(Button)
const AuthLinkButton = authorizeBase(LinkButton)

moment.locale('zh-cn');
const {Option} = Select;

const status = {
    T: '目的地',
    D: '转关地',
    F: '出发地',
    C: '清关地',
};

class AddressList extends Component {

    state = {
        total: 0, // 商品的总数量
        companyList: [], // 商品的数组
        pageNum: 1,
        action: '',
        visible:false,
        country: {},
        cityVisible: false,
        city: {}
    }

    /*
     初始化table的列的数组
     */
    initColumns = () => {

    }

    componentWillMount() {
        this.initColumns()
    }

    getProducts = async (pageNum) => {
        const pageSize = 10
        this.setState({
            pageNum: pageNum// 保存pageNum, 让其它方法可以看到
        })
        const {getFieldsValue} = this.props.form
        const values = getFieldsValue();
        values.pageNum = pageNum;
        values.pageSize = pageSize;
        let result = await reqCountryCityList(values)
        if (result.code === 200) {
            this.setState({
                total: result.data.total,
                companyList: result.data.rows
            })
        } else if (result.code === 401) {
            this.props.history.replace('/login')
        } else {

        }

    }

    componentDidMount() {
        this.getProducts(1)
    }

    /*查询列表*/
    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            values.pageNum = 1
            values.pageSize = 10;
            this.setState({
                pageNum:values.pageNum
            })
            if (!err) {
                this.reqCountryCityList(values);
            }
        });
    };

    reqCountryCityList = async (po) => {
        const result = await reqCountryCityList(po);
        if (result.code === 200) {
            this.setState({
                total: result.data.total,
                companyList: result.data.rows
            })
            this.initColumns()
        } else {
            message.error(result.message);
        }
    };


    handleTableChange = (pagination, filters, sorter) => {
        const pager = { ...this.state.pagination };
        pager.current = pagination.current;
        this.setState({
            pagination: pager,
        });
        const pageNum = pagination.current
        this.getProducts(pageNum)
    };

    // 新增
    addCity = () => {
        this.setState({
            cityVisible: true,
            city : {

            },
            action:'add',
        })
    }

    // 修改
    updateCity =(data) => {
        this.setState({
            cityVisible: true,
            action:'update',
            city : {
                id: data.cityId,
                name: data.cityName,
                nameEn: data.cityEnName,
                countryId: data.countryId,
                type: data.type
            },
        })
    }

    onCityCancel = () => {
        this.setState({
            cityVisible: false
        })
    }

    // 新增
    getAddCity = async (po) => {
        const {pageNum} = this.state
        const result = await reqAddCity(po);
        if (result.code === 201) {
            this.onCityCancel()
            this.getProducts(pageNum)
        } else {
            message.error(result.message);
        }
    };

    // 更新
    getUpdateCity = async (po) => {
        const {pageNum} = this.state
        const result = await reqUpdateCity(po);
        if (result.code === 200) {
            this.onCityCancel()
            this.getProducts(pageNum)
        } else {
            message.error(result.message);
        }
    };

    // 删除
    getDeleteCity = async (id) => {
        const result = await reqDeleteCity(id);
        if (result.code === 200) {
            this.getProducts(1)
        } else {
            message.error(result.message);
        }
    };

    onCityOk = data => {
        const {action} = this.state;
        if (action === 'add') {
            this.getAddCity(data)
        } else {
            this.getUpdateCity(data)
        }
    }

    // 新增
    addCountry = () => {
        this.setState({
            visible: true,
            country : {

            },
            action:'add',
        })
    }

    // 修改
    updateCountry =(data) => {
        this.setState({
            visible: true,
            action:'update',
            country : {
                id: data.countryId,
                name: data.countryName,
                nameEn: data.countryEnName
            },
        })
    }

    onCountryCancel = () => {
        this.setState({
            visible: false
        })
    }

    // 新增
    getAddCountry = async (po) => {
        const {pageNum} = this.state
        const result = await reqAddCountry(po);
        if (result.code === 201) {
            this.onCountryCancel()
            this.getProducts(pageNum)
        } else {
            message.error(result.message);
        }
    };

    // 更新
    getUpdateCountry = async (po) => {
        const {pageNum} = this.state
        const result = await reqUpdateCountry(po);
        if (result.code === 200) {
            this.onCountryCancel()
            this.getProducts(pageNum)
        } else {
            message.error(result.message);
        }
    };

    // 删除
    getDeleteCountry = async (id) => {
        const result = await reqDeleteCountry(id);
        if (result.code === 200) {
            this.getProducts(1)
        } else {
            message.error(result.message);
        }
    };

    onCountryOk = data => {
        const {action} = this.state;
        if (action === 'add') {
            this.getAddCountry(data)
        } else {
            this.getUpdateCountry(data)
        }
    }


    render() {
        const form = this.props.form
        const {getFieldDecorator} = form;

        const formItemLayout = {
            labelCol: {
                xs: {span: 9},
                sm: {span: 9},
            },
            wrapperCol: {
                xs: {span: 13},
                sm: {span: 13},
            },
        }

        const rowSelection = {
            onChange: (selectedRowKeys, selectedRows) => {
                console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
            },
            getCheckboxProps: record => ({
                disabled: record.name === 'Disabled User', // Column configuration not to be checked
                name: record.name,
            }),
        }

        // 取出状态数据
        const {companyList, total,deviceView} = this.state
        const columns = [
            {
                title: '国家(中文)',
                dataIndex: 'countryName',
                width: '10%'
            },
            {
                title: '国家(英文)',
                dataIndex: 'countryEnName',
            },
            {
                title: '城市(中文)',
                dataIndex: 'cityName',
            },
            {
                title: '城市(英文)',
                dataIndex: 'cityEnName',
            }, {
                title: '类型',
                dataIndex: 'type',
                render: (text, record) => (
                    <span>
                        {status[text]}
                    </span>
                )
            }, {
                title: '操作',
                dataIndex: 'opt',
                fixed: 'right',
                width: 150,
                render: (text, record) => {
                    if(record.cityId && record.cityBelong === 'ktcrm') {
                        return <span>
                                <AuthLinkButton authority="address:updateCity"
                                            onClick={() => this.updateCity(record)}>修改</AuthLinkButton>
                                <Popconfirm title="是否确认删除城市?" onConfirm={() => this.getDeleteCity(record.cityId)}>
                                    <AuthLinkButton authority="address:deleteCity" >删除</AuthLinkButton>
                                </Popconfirm>
                            </span>
                    } else if (!record.cityId) {
                        if (record.belong==='ktcrm') {
                            return <span>
                                <AuthLinkButton authority="address:updateCountry"
                                            onClick={() => this.updateCountry(record)}>修改</AuthLinkButton>
                                <Popconfirm title="是否确认删除国家?" onConfirm={() => this.getDeleteCountry(record.countryId)}>
                                    <AuthLinkButton authority="address:deleteCountry" >删除</AuthLinkButton>
                                </Popconfirm>
                            </span>
                        }
                    }

                }
            }
        ];

        return (
            <div className='box-shadow padding-20'>
                <div className='head-title'>国家城市列表</div>
                <br/>
                <Form {...formItemLayout} onSubmit={this.handleSubmit}>
                    <Row>
                        <Col span={5}>
                            <Form.Item label="国家">
                                {getFieldDecorator('countryName', {})(<Input />)}
                            </Form.Item>
                        </Col>
                        <Col span={5}>
                            <Form.Item label="城市">
                                {getFieldDecorator('cityName', {})(<Input />)}
                            </Form.Item>
                        </Col>
                        <Col span={5}>
                            <Form.Item label="类型">
                                {getFieldDecorator('type', {
                                    initialValue: '',
                                })(<Select getPopupContainer={triggerNode => triggerNode.parentNode}>
                                    <Option value="">全部</Option>
                                    <Option value="F">出发地</Option>
                                    <Option value="D">转关地</Option>
                                    <Option value="T">目的地</Option>
                                    <Option value="C">清关地</Option>
                                </Select>)}
                            </Form.Item>
                        </Col>
                        <Col span={8} style={{float: 'right', marginBottom: '20px'}}>
                            <Button type='primary' htmlType="submit"
                                    style={{float: 'right', marginRight: '5%'}}>查询</Button>
                            <AuthButton authority="address:addCountry" type="primary"
                                    style={{float: 'right', marginRight: '5%'}} onClick={this.addCountry}>新增国家</AuthButton>
                            <AuthButton authority="address:addCity" type="primary"
                                    style={{float: 'right', marginRight: '5%'}} onClick={this.addCity}>新增城市</AuthButton>
                        </Col>
                    </Row>
                </Form>

                <Table
                    rowSelection={rowSelection}
                    columns={columns}
                    bordered
                    dataSource={companyList}
                    rowKey='id'
                    onChange={this.handleTableChange}
                    pagination={{
                        current: this.state.pageNum,
                        total: total,
                        showQuickJumper: true,
                    }}
                    size="middle"
                />
                <CountryModal
                    visible={this.state.visible}
                    onCountryOk={this.onCountryOk}
                    action={this.state.action}
                    country={this.state.country}
                    onCountryCancel={this.onCountryCancel}
                />
                <CityModal
                    visible={this.state.cityVisible}
                    onCityOk={this.onCityOk}
                    action={this.state.action}
                    city={this.state.city}
                    onCityCancel={this.onCityCancel}
                />
            </div>

        )
    }
}
const AddressListFrom = Form.create()(AddressList)
export default AddressListFrom